import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom'; 
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap'; //  Col
import ReactQuill from 'react-quill'; 
import '../../assets/css/quill-snow.css';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import { ROUTE_REFRESH,LOGIN_AFFILIATE_GROUP,LOGIN_CLIENT_GROUP,LOGIN_CREW_GROUP,ROUTE_SA_SETTINGS } from '../../configs/staticConfigs'; // , LOGIN_OMNU_AFFILIATE_GROUP
import { MSG_REQUIRED,MSG_TERMS_FETCH_FAILED,MSG_TERMS_ADD_SUCCESS,MSG_TERMS_ADD_FAILED,MSG_TERMS_UPDATE_SUCCESS,MSG_TERMS_UPDATE_FAILED,MSG_TERMS_DATA_EMPTY } from '../../configs/msgConfigs';  
import { LBL_GROUP,LBL_APP_NAME, LBL_SETTINGS, LBL_AFFILIATES, LBL_CLIENTS, LBL_CREW, LBL_BTN_ADDNEW, LBL_SAVE, LBL_TERMS_AND_CONDITIONS, LBL_AFFILIATE, LBL_TERMS_SAVE_NEW,LBL_CONFIRM_DELETE,LBL_BACK_TO_SETTINGS} from '../../configs/labelConfigs'; 

import { termsFetchAction, termsAddAction, termsUpdateAction } from '../../actions/termsActions'; 
import { clearAction } from '../../actions/commonActions';
import { TERMS_FETCH_SUCCESS,TERMS_FETCH_ERROR,TERMS_ADD_SUCCESS,TERMS_ADD_ERROR,TERMS_UPDATE_SUCCESS,TERMS_UPDATE_ERROR } from '../../actions'; 

class TermsAndConditionsComponent extends Component {

    constructor(props){
        super(props)        

        this.state = {   
            formErrors:{
                fieldEmpty:''              
            },          
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            headerText: '',
            commonErrMsg:'',
            dynamicFieldName:'',
            selectedGroupId: '', 
            activeTermsId: 0,
            saveNewTerms: true,
            saveNewTermsCrew: true,
            saveNewTermsClients: true,
            saveNewTermsAffiliates: true,
            saveNewTermsClients: true,
            termsItems:[],
            activeTermsText: '', 
        }
    }

    resetTermsData = () => {
        this.setState({
            activeTermsId: 0,
            activeTermsText: '',
            termsItems:[]
        });
    }

    onHandleTermsTextChange = (activeTermsText) => {
        this.setState({activeTermsText});
    }

    onHandleChange = (e,daType) => {
        if(daType=='termsText') this.setState({activeTermsText:e.target.value}); 
        if(daType=='saveNew') {
            if(this.state.selectedGroupId==LOGIN_AFFILIATE_GROUP) this.setState({saveNewTerms:e.target.checked, saveNewTermsAffiliates:e.target.checked});  
            else if(this.state.selectedGroupId==LOGIN_CLIENT_GROUP) this.setState({saveNewTerms:e.target.checked, saveNewTermsClients:e.target.checked});  
            else if(this.state.selectedGroupId==LOGIN_CREW_GROUP) this.setState({saveNewTerms:e.target.checked, saveNewTermsCrew:e.target.checked});  
        }

        if(!e.target.value.trim().length) {
            this.setState({commonErrMsg:MSG_TERMS_DATA_EMPTY}); 
        }
        else {
            this.setState({commonErrMsg:''}); 
        }
    }

    componentDidMount() {
        this.changePage('',LOGIN_AFFILIATE_GROUP); 
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_TERMS_AND_CONDITIONS; // +' '+uType;
    }

    changePage = (event, selectedGroupId) => {    
        this.resetTermsData();    
        let headerText = LBL_TERMS_AND_CONDITIONS; 
        if(selectedGroupId==LOGIN_AFFILIATE_GROUP) headerText += ' - '+LBL_AFFILIATES; 
        else if(selectedGroupId==LOGIN_CLIENT_GROUP) headerText += ' - '+LBL_CLIENTS; 
        else if(selectedGroupId==LOGIN_CREW_GROUP) headerText += ' - '+LBL_CREW; 

        if(selectedGroupId==LOGIN_AFFILIATE_GROUP) this.setState({selectedGroupId, headerText, saveNewTerms:this.state.saveNewTermsAffiliates});  
        else if(selectedGroupId==LOGIN_CLIENT_GROUP) this.setState({selectedGroupId, headerText, saveNewTerms:this.state.saveNewTermsClients});  
        else if(selectedGroupId==LOGIN_CREW_GROUP) this.setState({selectedGroupId, headerText, saveNewTerms:this.state.saveNewTermsCrew});  
        this.fetchTerms(selectedGroupId); 
    }

    fetchTerms = (selectedGroupId) => {
        this.props.termsFetchAction({groupId:selectedGroupId}); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    onModalFormReset = () =>{ 
        // this.setState({}); 
    }
  
    saveFormData = (e) => { 
        e.preventDefault(); 
        this.setState({commonErrMsg:'',formClick:true}); 
        if(!this.state.activeTermsText || !this.state.activeTermsText.trim().length) { 
            this.setState({commonErrMsg:MSG_TERMS_DATA_EMPTY}); 
        } 
        else { 
            // TermsId  SaveNew   Action
            //   no       no      Create
            //   yes      no      Update
            //   no       yes     Create
            //   yes      yes     Create

            if(parseInt(this.state.activeTermsId,10) && !this.state.saveNewTerms) { 
                // CALL TERMS UPDATE FUNCTION 
                this.props.termsUpdateAction({id:this.state.activeTermsId, condition_text:this.state.activeTermsText, group:this.state.selectedGroupId}); 
            }
            else {
                // CALL TERMS CREATE FUNCTION 
                this.props.termsAddAction({condition_text:this.state.activeTermsText, group:this.state.selectedGroupId}); 
            }
        }
    }
    

    componentDidUpdate(prevProps) {    
       
        const { status, activity, termsItems } = this.props; 
        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            
            var arrResp = activity.split('~~'); 
            var actString = arrResp[0]; 
            if(actString===TERMS_FETCH_SUCCESS) { 
                if(!termsItems || termsItems.length==0) {
                    this.resetTermsData(); 
                }
                else {
                    this.setState({
                        activeTermsId: termsItems[0].id,
                        activeTermsText: termsItems[0].condition_text,
                        termsItems:termsItems,
                    });
                }
            }
            else if(actString===TERMS_FETCH_ERROR) { 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TERMS_FETCH_FAILED});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            }
            else if(actString===TERMS_ADD_SUCCESS) {
                this.fetchTerms(this.state.selectedGroupId); 
                this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_TERMS_ADD_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            }
            else if(actString===TERMS_ADD_ERROR) {
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TERMS_ADD_FAILED});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            }
            else if(actString===TERMS_UPDATE_SUCCESS) {
                this.fetchTerms(this.state.selectedGroupId); 
                this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_TERMS_UPDATE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            }
            else if(actString===TERMS_UPDATE_ERROR) {
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TERMS_UPDATE_FAILED});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            }
        }
    }

    render(){
      
        const { status } = this.props;
        const { toastMessage, toastFlag, toastSuccess } = this.state;        

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        let selectedGroupId = this.state.selectedGroupId; 

        // let toolbarOptions = [
        //     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //     [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //     [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //     [{ 'direction': 'rtl' }],                         // text direction
        //     [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        //     [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        //     [{ 'font': [] }],
        //     [{ 'align': [] }],
        //     ['clean']                                         // remove formatting button
        // ];

        let toolbarOptions = [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline'],                  // toggled buttons
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'align': [] }],
            ['clean']                                         // remove formatting button
        ];

        // Normal, Bold, I, U, Link, Numbering, Bullets, Clear

        return(
            <React.Fragment>

                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className='row' style={{width: '100%', marginLeft: '1px'}}>
                     <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                </div>
                          
                <Tab.Container id="terms-tab" defaultActiveKey="terms-data-tab">
                             
          

                    <div className="col-md-4 col-lg-3 col-xl-2 col-12">
                        <div className="box">
                            <div className="tab-head">
                            <div className="text-bold normalText leftPanelHeading ">{LBL_GROUP}</div>
                            </div>
                        </div>
                         
                        <Nav variant="pills" className="nav flex-column nav-pills box">
                            <Nav.Link className={selectedGroupId==LOGIN_AFFILIATE_GROUP ? "active" : ''} onClick={ (e) => selectedGroupId!==LOGIN_AFFILIATE_GROUP ? this.changePage(e, LOGIN_AFFILIATE_GROUP) : '' } >
                                {/* <i className='las la-users-cog Affiliates'></i>  */} {LBL_AFFILIATES}
                            </Nav.Link> 
                            <Nav.Link className={selectedGroupId==LOGIN_CLIENT_GROUP ? "active" : ''} onClick={ (e) => selectedGroupId!==LOGIN_CLIENT_GROUP ? this.changePage(e, LOGIN_CLIENT_GROUP) : '' } >
                                {/* <i className='las la-user-tie'></i> */} {LBL_CLIENTS}
                            </Nav.Link> 
                            <Nav.Link className={selectedGroupId==LOGIN_CREW_GROUP ? "active" : ''} onClick={ (e) => selectedGroupId!==LOGIN_CREW_GROUP ? this.changePage(e, LOGIN_CREW_GROUP) : '' } >
                                {/* <img src={require('../../'+URL_IMG+'crewlist-icon.svg')} width='24' alt='' /> */} {LBL_CREW}
                            </Nav.Link> 
                        </Nav>
                    </div>

                    <div className="col-md-4 col-lg-6 col-xl-7 col-9 pl-0">
                        <Tab.Content>
                            <Tab.Pane eventKey="terms-data-tab">
                                <div className="box">
                                    <div className="tab-head tdVeticalMiddle">
                                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{this.state.headerText}</h6></div>
                                        {/* <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button></div> */}
                                    </div>
                                    <div className="box-content">
                                        <div>
                                            <ReactQuill value={this.state.activeTermsText}
                                                onChange={this.onHandleTermsTextChange} theme="snow" modules={{ toolbar: toolbarOptions}} />
                                                {/* <div id="divTermsText"></div> 
                                            </ReactQuill> */}
                                        </div>
                                        <div>
                                            {/* <textarea className="form-control" name="termsAffiliates" onChange={e => this.onHandleChange(e,'termsText')} value={this.state.activeTermsText || ''}></textarea> */}
                                        </div>
                                    </div> 
                                    
                                    <div className="tab-head col-12">
                                        {this.state.commonErrMsg.length >0 && (
                                        <div className="text-red text-12 text-right">{this.state.commonErrMsg}</div> )} 
                                        <div className="custom-checkbox"> &nbsp;&nbsp;&nbsp;
                                            <input type="checkbox" name={'chk_show_tab_affiliates'} id={'chk_show_tab_affiliates'} 
                                            checked={this.state.saveNewTerms ? true : false} 
                                            onChange={(e) => this.onHandleChange(e,'saveNew')}  /> <label className="checkbox" htmlFor={'chk_show_tab_affiliates'}></label><label className="labeltext" htmlFor={'chk_show_tab_affiliates'}>{LBL_TERMS_SAVE_NEW}</label> 
                                        </div>
                                            
                                        <div className="float-right">  
                                            <button  type="button" className="btn btn-primary saveBtnMinWidth margin-right-10" onClick={this.saveFormData} >{LBL_SAVE}</button>      
                                        </div>  
                                    </div>
                                </div>       
                            </Tab.Pane>

                        </Tab.Content>
                    </div>
                </Tab.Container>               
                    
                <ModalWindow ref="modalDelete" header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> Are you sure you want to delete? </ModalWindow>  
                
                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        termsItems:state.terms.termsItems,
        status:state.terms.status,
        activity:state.terms.activity,
        errorData: state.terms.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        termsFetchAction:termsFetchAction, 
        termsAddAction:termsAddAction, 
        termsUpdateAction:termsUpdateAction,
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(TermsAndConditionsComponent);